module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-14-Scale.6eb7a434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-14-Scale.jpg
// module id = 948
// module chunks = 37